import React, { Component, Fragment } from 'react'
import './columnList.scss'
import $ from 'jquery'
import API from './../../config/api'
import tools from '../../utils/tool'
// import {connect} from 'react-redux';
// import {refresh_admin} from './../../redux/models/admin';
import { Toast } from 'antd-mobile'
// import Text from 'react-native/Libraries/Text/Text';

// 栏目列表页
// @connect(
//   state => ({admin: state.admin}),
//   {refresh_admin}
// )

class ColumnList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      listData: [],
      extInfo: {},
      page: 1,
      allDataLoaded: true, //true表示大于12条
      column_id: ''
    }

  }

  componentWillMount () {
    $('html,body').css({
      'background-color': '#ffffff'
    })
    this.getContentId()
    // 统计
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {

  }

  // shouldComponentUpdate() {
  //
  // }

  render () {
    return (
      <div className="columnList" style={{ margin: '0 auto', background: '#fff', position: 'relative', overflow: 'hidden' }}>
        <div className="head_box">
          <img src={this.state.extInfo.colimn_cover || require('@/assets/5363873822980255325.jpg')} className="head_bg" />
          <div className="mengban"></div>
          <div className="clearfix head">
            <div className="fl">
              <img src={this.state.extInfo.colimn_cover || require('@/assets/5363873822980255325.jpg')} className="head_img" />
            </div>
            <div className="fl name">
              <h3>{this.state.extInfo.column_name}</h3>
              {/* <p><i></i>已更新{this.state.extInfo.article_num}篇</p> */}
            </div>
          </div>
          <div className="miaoshu">
            <p>{this.state.extInfo.column_desc}</p>
          </div>
        </div>
        <div className="column_all">
          <h3 className="title"><i></i>全部</h3>
          <div className="list">
            <div className="no_data" style={{ display: this.state.listData.length === 0 ? 'block' : 'none' }}>
              <img src={require('@/assets/photoTaker_none@3x.png')} />
            </div>
            {this.state.listData.map((item, index) => {
              return (
                // show_type 3:无图 2:大图 1:左图右文，这里只分有图无图
                <Fragment key={index}>
                  {/* // 图文 */}
                  {item.type == 1 && item.show_type / 1 === 3 ? (
                    // 无图
                    <div className="list-no">
                      <a href={"#/detail/1/" + item.row.uuid} >
                        <h3>{item.row.title}</h3>
                        <div className="list-no-label">
                          {item.row.column_info.length>0 && item.row.column_info[0].column_name ? <span className="list-box-left-label-column">{item.row.column_info[0].column_name}</span>:''}
                          <span className="list-box-left-label-time">{this.format(item.row.publish_time)}</span>
                          <span className="list-box-left-label-volume">{item.row.com_zan_num}</span>
                        </div>
                      </a>
                    </div>
                  ) : item.type == 1 ? (
                    // 有图
                    <div className="list-box">
                      <a href={"#/detail/1/" + item.row.uuid} className="list-box-b">
                        <div className="list-box-left">
                          <h3>{item.row.title}</h3>
                          <div className="list-box-left-label">
                            {item.row.column_info.length>0 && item.row.column_info[0].column_name ? <span className="list-box-left-label-column">{item.row.column_info[0].column_name}</span>:''}
                            <span className="list-box-left-label-time">{this.format(item.row.publish_time)}</span>
                            <span className="list-box-left-label-volume">{item.row.com_zan_num}</span>
                          </div>
                        </div>
                        <div className="list-box-right" style={{ background: 'url(' + item.row.cover_list[0].url + ') no-repeat center', backgroundSize: 'cover' }}></div>
                      </a>
                    </div>
                  ) : ''}

                  {/* // 视频 */}
                  {item.type == 2 && item.show_type / 1 === 3 ? (
                    <div className="list-no">
                      <a href={"#/detail/2/" + item.row.uuid + "/2"} >
                        <h3>{item.row.title}</h3>
                        <div className="list-no-label">
                          {item.row.column_info.length>0 && item.row.column_info[0].column_name ? <span className="list-box-left-label-column">{item.row.column_info[0].column_name}</span>:''}
                          <span className="list-box-left-label-time">{this.format(item.row.publish_time)}</span>
                          <span className="list-box-left-label-volume">{item.row.com_zan_num}</span>
                        </div>
                      </a>
                    </div>
                  ) : item.type == 2 ? (
                    //  else 
                    <div className="list-box">
                      <a className="list-box-b" href={"#/detail/2/" + item.row.uuid + "/2"} >
                        <div className="list-box-left">
                          <h3>{item.row.title}</h3>
                          <div className="list-box-left-label">
                            {item.row.column_info.length>0 && item.row.column_info[0].column_name ? <span className="list-box-left-label-column">{item.row.column_info[0].column_name}</span>:''}
                            <span className="list-box-left-label-time">{this.format(item.row.publish_time)}</span>
                            <span className="list-box-left-label-volume">{item.row.com_zan_num}</span>
                          </div>
                        </div>
                        <div className="list-box-right" style={{ background: 'url(' + item.row.cover_list[0].url + ') no-repeat center', backgroundSize: 'cover' }}>
                          <div className="list-box-right-Play"></div>
                          <span class="list-box-right-time">{this.setHis(parseInt(item.row.ext_data.duration))}</span>
                        </div>
                      </a>
                    </div>
                  ) : ''}
                  {/* // 图说 */}
                  {item.type == 4 && item.show_type / 1 === 3 ? (
                    // 无图
                    <div className="list-no">
                      <a href={"#/detail/3/" + item.row.uuid} >
                        <h3>{item.row.title}</h3>
                        <div className="list-no-label">
                          {item.row.column_info.length>0 && item.row.column_info[0].column_name ? <span className="list-box-left-label-column">{item.row.column_info[0].column_name}</span>:''}
                          <span className="list-box-left-label-time">{this.format(item.row.publish_time)}</span>
                          <span className="list-box-left-label-volume">{item.row.com_zan_num}</span>
                        </div>
                      </a>
                    </div>
                  ) : item.type == 4 ? (
                    // 有图
                    <div className="list-box">
                      <a href={"#/detail/3/" + item.row.uuid} className="list-box-b">
                        <div className="list-box-left">
                          <h3>{item.row.title}</h3>
                          <div className="list-box-left-label">
                            {item.row.column_info.length>0 && item.row.column_info[0].column_name ? <span className="list-box-left-label-column">{item.row.column_info[0].column_name}</span>:''}
                            <span className="list-box-left-label-time">{this.format(item.row.publish_time)}</span>
                            <span className="list-box-left-label-volume">{item.row.com_zan_num}</span>
                          </div>
                        </div>
                        <div className="list-box-right" style={{ background: 'url(' + item.row.cover_list[0].url + ') no-repeat center', backgroundSize: 'cover' }}></div>
                      </a>
                    </div>
                  ) : ''}
                  {/* // 音频 */}
                  {item.type == 21 && item.show_type / 1 === 3 ? (
                    // 无图
                    <div className="list-no">
                      <a href={"#/detail/21/" + item.row.uuid + "/21"} >
                        <h3>{item.row.title}</h3>
                        <div className="list-no-label">
                          {item.row.column_info.length>0 && item.row.column_info[0].column_name ? <span className="list-box-left-label-column">{item.row.column_info[0].column_name}</span>:''}
                          <span className="list-box-left-label-time">{this.format(item.row.publish_time)}</span>
                          <span className="list-box-left-label-volume">{item.row.com_zan_num}</span>
                        </div>
                      </a>
                    </div>
                  ) : item.type == 21 ? (
                    // 有图
                    <div className="list-box">
                      <a href={"#/detail/21/" + item.row.uuid + "/21"} className="list-box-b">
                        <div className="list-box-left">
                          <h3>{item.row.title}</h3>
                          <div className="list-box-left-label">
                            {item.row.column_info.length>0 && item.row.column_info[0].column_name ? <span className="list-box-left-label-column">{item.row.column_info[0].column_name}</span> : ''}
                            <span className="list-box-left-label-time">{this.format(item.row.publish_time)}</span>
                          </div>
                        </div>
                        <div className="list-box-right-Play"></div>
                      </a>
                    </div>
                  ) : ''}
                </ Fragment>
              )
            })}
          </div>
          <div className="load" style={{display: this.state.allDataLoaded ? 'none' : 'block'}}>{this.state.listData.length === 0 ? '暂无数据' : '已经到底了'}</div>
        </div>
      </div>
    )
  }

  format = (times) => {
    if (times) {
      //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
      //计算多久前发布
      var time = new Date(times)
      // console.log(time)
      var dqtime = new Date()
      var date = dqtime.getTime() - time.getTime()
      date = Math.floor(date / 1000)
      if (date <= 59) {
        return date + '秒前'
        // datetime.push(date + '秒前')
      } else if (date <= 3599) {
        date = Math.floor(date / 60)
        return date + '分钟前'
        // datetime.push(date + '分钟前')
      } else if (date <= 86399) {
        date = Math.floor(date / 60 / 60)
        return date + '小时前'
        // datetime.push(date + '小时前')
      } else {
        date = Math.floor(date / 60 / 60 / 24)
        if (date < 2) {
          return '1天前'
          // datetime.push('1天前')
        } else {
          var y = time.getFullYear() //getFullYear方法以四位数字返回年份
          var M = time.getMonth() + 1 // getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一
          var d = time.getDate() // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
          var h = time.getHours() // getHours方法返回 Date 对象的小时 (0 ~ 23)
          var m = time.getMinutes() // getMinutes方法返回 Date 对象的分钟 (0 ~ 59)
          var s = time.getSeconds() // getSeconds方法返回 Date 对象的秒数 (0 ~ 59)    
          if (y == dqtime.getFullYear()) {
            return M + '月' + d + '日'
          } else {
            return y + '年' + M + '月' + d + '日'
          }
          // datetime.push(y + '-' + M + '-' + d)
          // datetime.push(date + '天前')
        }
      }
    } else {
      return ''
    }
  }
  // 视频显示 分:秒
  setHis (params) {
    if (params) {
      // var h = parseInt(params/3600);
      var m = parseInt((params % 3600) / 60) //分
      var s = ((params % 3600) % 60)         //秒
      // if( m==0 ){
      //     return ( '00') +':' + (s < 10 ? '0'+s : s )
      // }
      if (m < 10) {
        return ('0' + m) + ':' + (s < 10 ? '0' + s : s)
      }
    } else {
      return '00:00'
    }
  }

  getContentId () {  //获取内容id
    // console.log(this.props);
    const { column_id } = this.props.match.params
    if (column_id) {
      this.setState({
        column_id: column_id
      },() => {
        this.getContent()
        this.statistics()
      })
    } else {
      this.props.history.push('./')
    }
  }

  //数据流接口
  getContent () {
    const { column_id, page } = this.state
    $.ajax({
      type: 'get',
      url: API.column_news,
      async: false,
      data: {
        column_id: column_id,
        page: page,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0) {
        if(this.state.allDataLoaded){
          // 每次请求到新数据插入数组的尾部
          this.setState({
            listData: [...this.state.listData, ...res.data],
            extInfo: res.extInfo,
            page: page + 1
          })
          if(res.data.length<12){
            this.setState({
              allDataLoaded: false
            })
          }
        }
        this.initWx({
          title: res.extInfo.column_name,
          desc: res.extInfo.dch_desc,
        })
      } else {
        Toast.fail(res.msg || res.error)
      }
    })
  }

  handleScroll = () => {
    const scrollPosition = window.scrollY
    const windowHeight = window.innerHeight
    const scrollHeight = document.documentElement.scrollHeight
    // if (scrollPosition + windowHeight >= scrollHeight) {  
    //   this.getContent(); // 当滚动到底部时，加载下一页数据  
    // } 
    const scrollBottom = scrollPosition + windowHeight
    const scrollDistance = scrollHeight - scrollBottom

    if (scrollDistance <= 1 && this.state.allDataLoaded) {  // 当滚动到底部时，加载下一页数据  
      this.getContent()
    }
  }

  goDetail (item) {
    switch (parseInt(item.type)) {
      case 1:     //图文
        this.props.history.push('/detail/1/' + item.uuid)
        break
      case 2:     //视频
        this.props.history.push('/detail/2/' + item.uuid + '/2')
        break
      case 4:     //图说
        this.props.history.push('/detail/3/' + item.uuid)
        break
      case 6:     //直播
        this.props.history.push('/detail/2/' + item.uuid + '/6')
        break
      case 21:    //音频
        this.props.history.push('/detail/21/' + item.uuid + '/21')
        break
    }
  }

  statistics (share) {
    var op = share ? 'share' : 'pv'
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = API.pv + '?xm=bjnews&wz=article_detail&op=' + op + '&pt=web&unique_id=' + this.state.column_id     //填自己的js路径
    $('body').append(script)
  }

  initWx (obj) {
    //分享
    var wxconfig = new window.WxConfig()
    console.log(window.location.href)
    wxconfig.init({
      appid: API.appid,
      url: window.location.href,
      title: obj.title,
      desc: obj.desc || API.share_des,
      link: window.location.href,
      imgUrl: API.share_img,
      successCallback: this.statistics.bind(this, true)
    })
  }

}

export default ColumnList


// WEBPACK FOOTER //
// ./src/pages/ColumnList/columnList.js